/**
 * useDashboard — Hook para consumir /api/dashboard/summary
 *
 * Retorna { data, loading, error, refetch }
 * Formato de data idêntico ao generateMockDashboard para drop-in replacement.
 */

import { useState, useEffect, useCallback, useRef } from 'react'
import { getDashboard, setSelectedClientId } from '../db/api.js'

export function useDashboard(startDate, endDate, campaignIds, clientId) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // Ref para evitar race conditions entre re-fetches
  const requestIdRef = useRef(0)

  // Estabiliza a dependência: strings com mesmo conteúdo são === entre renders.
  // Arrays não são — por isso convertemos para chave estável.
  const campaignIdsKey = Array.isArray(campaignIds)
    ? campaignIds.slice().sort().join(',')
    : ''

  const refetch = useCallback(async () => {
    if (!startDate || !endDate) return

    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)

    try {
      setSelectedClientId(clientId)
      const ids = campaignIdsKey ? campaignIdsKey.split(',') : []
      const result = await getDashboard(startDate, endDate, ids)
      if (requestId !== requestIdRef.current) return // stale
      setData(result)
    } catch (err) {
      if (requestId !== requestIdRef.current) return // stale
      console.error('[useDashboard] fetch error:', err)
      setError(err.message || 'Erro ao carregar dashboard')
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false)
      }
    }
  }, [startDate, endDate, campaignIdsKey, clientId])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { data, loading, error, refetch }
}
